import React from 'react';
import { EmptyText, EmptyTitle, EmptyWrapper, ListWrapper, StarWrapper, Title, Wrapper } from './styled';
import { useLocale } from 'locale';
import IconStar from 'assets/svg/investors-neighbourhood/save-filled.svg';
import { State } from 'store/state';
import { connect } from 'react-redux';
import { favoriteNeighbourhoodsDataSelector, favoriteNeighbourhoodsIsLoadingSelector } from 'store/state/domainData/selectors';
import { IFavoriteNeighbourhood } from 'store/sagas/apiService/types';
import { SpacingBlock } from 'components/spacing-block';
import Spinner from 'components/widget/prices/prices-table/tables/history/affiliation/Spinner';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { Card } from '../components/Card';
import { navigateTo } from 'store/state/router/actions';
import { NavigateToFn, Route } from 'config/routes';


const InvestorsFavoriteNeighourhoodPageBase: React.FC<{ list: IFavoriteNeighbourhood[]; isLoading: boolean; navigate: NavigateToFn }> = ({ list, isLoading, navigate }) => {
  const { t } = useLocale();
  const screen = useScreenBreakpoint();
  const isDevice = screen < 3;

  if (isLoading || !list) {
    return (
      <EmptyWrapper>
        <SpacingBlock mTop={5} />
        <Spinner />
        <SpacingBlock mTop={5} />
      </EmptyWrapper>
    );
  }

  const emptyContent = (
    <EmptyWrapper>
      <StarWrapper>
        <IconStar width={96} height={96} />
      </StarWrapper>
      <EmptyTitle>{t('investors.favorite.neighbourhoods.emptyTitle')}</EmptyTitle>
      <EmptyText>{t('investors.favorite.neighbourhoods.emptyText')}</EmptyText>
    </EmptyWrapper>
  );

  return list && list.length ? (
    <Wrapper>
      {isDevice ? null : <Title weight="bold">{t('investors.favorite.neighbourhoods.title', { count: list.length })}</Title>}
      <ListWrapper>{
        list.map((n, i) => {
          const handleClick = () => navigate(Route.InvestorsNeighbourhoodPage, { id: n.doc.docId });
          const data = {
            neighborhoodDocId: n && n.doc.docId || '',
            neighborhoodName: n && n.doc.ref.__typename === 'Neighbourhood' ? n.doc.ref.neighbourhood : '',
            cityName: n && n.doc.ref.city || '',
            neighborhoodCardLabels: n && n.investorCard && n.investorCard.labels,
          };
          const info = {
            apartments: n.matchedListingsCount,
            views: n.investorCard && n.investorCard.monthlyViews || null,
          };

          return (
            isDevice ? (
              <div style={{ width: '100%' }} onClick={handleClick} key={i}>
                <Card data={data} info={info} withFavoriteStar />
              </div>
            ) : (
              <div style={{ width: 376 }} onClick={handleClick}>
                <Card key={i} data={data} info={info} withFavoriteStar />
              </div>
            )
          );
        })
      }</ListWrapper>
    </Wrapper>
  ) : emptyContent;
};

const mapStateToProps = (state: State) => ({
  list: favoriteNeighbourhoodsDataSelector(state),
  isLoading: favoriteNeighbourhoodsIsLoadingSelector(state),
});

const mapDispatchToProps = {
  navigate: navigateTo,
};

export const InvestorsFavoriteNeighourhoodPage = connect(mapStateToProps, mapDispatchToProps)(InvestorsFavoriteNeighourhoodPageBase);
